import { parse, stringify } from 'query-string';
import { MutableRefObject } from 'react';

export const PRODUCTS_PER_PAGE_PARAM = 'product_list_limit';

interface ChangeProductsPerPageParams {
    location: { pathname: string; search: string };
    history: { push: (path: string) => void };
    queryData: Record<string, unknown>;
    setQueryData: (q: any) => void;
    setPageNumber: (n: number) => void;
    currentPage: MutableRefObject<number>;
}

export const changeProductsPerPage = (
    newSize: string,
    { location, history, queryData, setQueryData, setPageNumber, currentPage }: ChangeProductsPerPageParams,
): void => {
    const current = parse(location.search);
    if ('p' in current) {
        delete current.p;
        const search = stringify(current);
        history.push(location.pathname + (search ? '?' + search : ''));
    }

    const newQueryData: Record<string, unknown> = { ...queryData, [PRODUCTS_PER_PAGE_PARAM]: newSize };
    delete newQueryData.p;
    setQueryData(newQueryData);
    setPageNumber(1);
    currentPage.current = 1;
};
